import type { TOC } from '@ember/component/template-only';
import { array } from '@ember/helper';
import VisualComplianceDetails from 'garaje/components/visual-compliance-details';
import type { VisualComplianceReport } from 'garaje/models/screener-result';
import type ScreenerResult from 'garaje/models/screener-result';
import type { GuestWithVisitApproval } from 'garaje/models/visit-approval';
import _countBy from 'lodash/countBy';

interface VisualComplianceSignature {
  Args: {
    result: ScreenerResult<VisualComplianceReport>;
    model: GuestWithVisitApproval;
  };
  Blocks: {
    default: [];
  };
}

export default <template>
  <li class="text-sm mt-4">
    <span>Visual Compliance match found</span>
    <VisualComplianceDetails
      class="list-disc ml-2 mt-1 list-inside"
      @model={{@model}}
      @visitApproval={{@model.visitApproval}}
      @reports={{array @result.report}}
      @hideReviewButton={{true}}
    />
  </li>
  {{yield}}
</template> satisfies TOC<VisualComplianceSignature>;
